// removed by extract-text-webpack-plugin
module.exports = {"hidden":"DDknq","visuallyhidden":"_3NLAv","hide-text":"_19pFM","center":"_2TjYQ","noprint":"_1btOV","root":"_35JqV"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-article/styles/default.scss
 ** module id = 986
 ** module chunks = 2
 **/